import { atom } from "jotai";
import type { Schema } from "prosemirror-model";
import type { Plugin } from "prosemirror-state";

import { store } from "../store";

export type PluginFactoryOptions = {
	documentId: string;
	pageId: string;
	schema: Schema;
	readonly: boolean;
	version?: number;
};

export type PluginFactory = (options: PluginFactoryOptions) => Plugin[];

const $pluginFactoryContainer = atom({} as { factory: PluginFactory | undefined });

/**
 * Atom holding the plugin factory function. MUST be set via registerPluginFactory() before
 * documents can be loaded.
 */
export const $pluginFactory = atom((get) => get($pluginFactoryContainer).factory);
$pluginFactory.debugLabel = "pluginFactory";

/**
 * Registers the plugin factory. Call this at app initialization. The factory is used by the
 * document loader to create ProseMirror plugins.
 */
export const registerPluginFactory = (factory: PluginFactory): void => {
	store.set($pluginFactoryContainer, { factory });
};
